import script from "./ModalJoinCampaignResultError.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalJoinCampaignResultError.vue?vue&type=script&setup=true&lang=js"

import "./ModalJoinCampaignResultError.vue?vue&type=style&index=0&id=45c23a62&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c23a62"]])

export default __exports__